import { alertVariants } from "@visiblethread/react-components";

import {
  SHAREPOINT_ERROR_CODES,
  SITE_NOT_ALLOWED_MESSAGE,
} from "../../../constants/sharepointAccess";
import { showGlobalAlert } from "../../app/appSlice";
import { setIsSharepointAuthorized } from "../sharepointSlice";
import { authenticateSharepoint } from "./authenticateSharepoint";
import { reloadSharepointRoot } from "./reloadSharepointRoot";
import { errorCodeOf, redirectUnlessSharepointError } from "./utils";

export const requireSharepointSignIn = (dispatch) => {
  dispatch(setIsSharepointAuthorized(false));
  dispatch(authenticateSharepoint({ forcePrompt: true }));
};

export const handleNotAllowed = (dispatch) => {
  dispatch(
    showGlobalAlert({
      text: SITE_NOT_ALLOWED_MESSAGE,
      variant: alertVariants.danger,
    })
  );
  dispatch(reloadSharepointRoot());
};

export const handledPolicyError = (dispatch, error) => {
  const code = errorCodeOf(error);
  if (code === SHAREPOINT_ERROR_CODES.SITE_NOT_ALLOWED) {
    handleNotAllowed(dispatch);
    return true;
  }
  if (code === SHAREPOINT_ERROR_CODES.POLICY_CHANGED) {
    dispatch(reloadSharepointRoot());
    return true;
  }
  if (code === SHAREPOINT_ERROR_CODES.AUTH_REQUIRED) {
    requireSharepointSignIn(dispatch);
    return true;
  }
  redirectUnlessSharepointError(error);
  return false;
};
